import * as React from 'react';
import { connect } from 'react-redux';

interface Props {
	answer?: string;
	questionName: string;
	questions: { [name: string]: string; }[];
	declinedQuestionNames: string[];
}

interface TravelAnswer {
	abroadLocation: string;
	abroadDuration: string;
}

class JsonAnswerDetails extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
	}
	render() {
		const answerObject = JSON.parse(this.props.answer!);

		return this.props.questionName === 'abroad' ? 
			(answerObject !== false ? (
			answerObject.map((subObject: TravelAnswer, index: number) => {
				return (
					<ul key={index} className="mb-0">
						<li>
							<strong>{subObject.abroadLocation} - </strong>
							{this.formatAbroadDuration(subObject.abroadDuration)}
						</li>
					</ul>
				);
			})
		) : (
			<div className="em">None</div>
		)) : 
		(Object.keys(answerObject).map((key: string) => {
			return (
				!key.includes('isValid') &&
				(!key.includes('None') ?
				(answerObject[key] !== false && !this.isMedicalOtherDetails(key) &&
					(
						<ul key={key} className="mb-0">
							<li>{this.getQuestionTextByName(key, answerObject[key], answerObject)}</li>
							{typeof answerObject[key] !== 'boolean' && 
							<li>{typeof answerObject[key] !== 'boolean' && !this.isMedicalOtherDetails(key) && answerObject[key]}</li>}
						</ul>
					)
				) :
				(answerObject[key] === true &&
					(
						<div key={key}>
							None
						</div>
					))));
		}));
	}

	private formatAbroadDuration = (abroadDuration: string) => {
		switch (abroadDuration) {
			case '0-4':
				return 'Less than 4 weeks';
			case '4-12':
				return '4-12 weeks';
			case '13-26':
				return '13-26 weeks';
			case '26+':
				return 'More than 26 weeks';
			default:
				return;
		}
	}

	private isMedicalOtherDetails = (questionName: string) => {
		if (questionName === 'cancerOtherDetails' || questionName === 'heartDisorderOtherDetails' ||
			questionName === 'neurologicalDisorderOtherDetails' || questionName === 'respiratoryDisorderOtherDetails' ||
			questionName === 'gastrointestinalDisorderOtherDetails' || questionName === 'endocrineDisorderOtherDetails' ||
			questionName === 'immuneSystemDisorderOtherDetails' || questionName === 'musculoskeletalDisorderOtherDetails' ||
			questionName === 'reproductiveDisorderOtherDetails' || questionName === 'psychologicalDisorderOtherDetails') {
			return true;
		}
		return false;
	}

	private getQuestionTextByName = (questionName: string, answerValue: any, answerObject?: any) => {
		var regex = /<.*?>/gi;
		let otherDetails = '';
		// the cancer one is actually a bug, better to fix it when we decide to change the way how we save answer into DB
		if (this.props.questions[questionName] === undefined || questionName === 'cancer') {
			// handle all hard-coded question text here
			switch (questionName) {
				// pets
				case 'dogs':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					return 'Dog(s)';
				case 'cats':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					return 'Cat(s)';
				case 'others':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					return 'Other(s)';														
				// cancer
				case 'cancer':
					return 'Any cancer or tumor except for basal cell carcinoma';
				case 'tumor':
					return 'Any tumor or growth not yet diagnosed';
				case 'dysplasticNeviSyndrome':
					return 'Dysplastic nevi syndrome';
				case 'cancerOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'cancerOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// heart & circulatory
				case 'elevatedCholesterol':
					return 'Elevated cholesterol or high blood pressure uncontrolled within the past 12 months';
				case 'chestPain':
					return 'Chest pain or angina';
				case 'shortnessOfBreath':
					return 'Shortness of breath';
				case 'heartAttack':
					return 'Heart attack (myocardial infarction)';
				case 'coronaryArteryDisease':
					return 'Coronary artery disease or carotid artery disease';
				case 'aneurysm':
					return 'Aneurysm';
				case 'valvularHeartDisease':
					return 'Valvular heart disease (e.g., mitral valve prolapse)';
				case 'cardiomyopathy':
					return 'Cardiomyopathy';
				case 'congestiveHeartFailure':
					return 'Congestive heart failure';
				case 'bypassOrAngioplasty':
					return 'Bypass surgery or angioplasty';
				case 'abnormalECG':
					return 'Abnormal ECG, cardiac stress test, or echocardiogram';
				case 'irregularPulse':
					return 'Irregular pulse';
				case 'heartMurmur':
					return 'Heart murmur';
				case 'pacemaker':
					return 'Pacemaker';
				case 'peripheralVascularDisease':
					return 'Peripheral vascular disease';
				case 'bloodClot':
					return 'Blood clot, embolism or clotting disorder';
				case 'heartDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'heartDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// neurological
				case 'epilepsy':
					return 'Epilepsy or seizures with any episodes within the past 12 months';
				case 'tremor':
					return 'Tremor';
				case 'huntingtonsDisease':
					return `Huntington's disease`;
				case 'brainAneurysm':
					return 'Brain aneurysm';
				case 'tia':
					return 'Transient ischemic attack (TIA)';
				case 'stroke':
					return 'Stroke';
				case 'parkinsonsDisease':
					return `Parkinson's disease`;
				case 'als':
					return `Motor neuron disease (Lou Gehrig's disease or ALS)`;
				case 'alzheimersDisease':
					return `Alzheimer's disease`;
				case 'cognitiveImpairment':
					return 'Cognitive impairment';
				case 'dementia':
					return 'Dementia';
				case 'multipleSclerosis':
					return 'Multiple sclerosis';
				case 'muscularDystrophy':
					return 'Muscular dystrophy';
				case 'lossOfBalance':
					return 'Loss of balance';
				case 'lossOfSpeech':
					return 'Loss of speech';
				case 'cerebralPalsy':
					return 'Cerebral palsy';
				case 'downSyndrome':
					return 'Down syndrome';
				case 'autism':
					return 'Autism';
				case 'developmentalDisorder':
					return 'Developmental disorder';
				case 'muscleWeakness':
					return 'Muscle weakness, tingling, or numbness of the extremities';
				case 'neurologicalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'neurologicalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// respiratory
				case 'sleepApnea':
					return 'Sleep apnea for which you are not treated';
				case 'emphysema':
					return 'Emphysema';
				case 'tuberculosis':
					return 'Tuberculosis';
				case 'sarcoidosis':
					return 'Sarcoidosis';
				case 'cysticFibrosis':
					return 'Cystic fibrosis';
				case 'asthma':
					return `Asthma requiring either a visit to the emergency room
					or the administration of oxygen within the past 12 months`;
				case 'copd':
					return 'Chronic obstructive pulmonary disease (COPD)';
				case 'respiratoryDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'respiratoryDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// liver
				case 'hepatitisBorC':
					return 'Hepatitis B or C';
				case 'cirrhosis':
					return 'Cirrhosis';
				case 'sclerosingCholangitis':
					return 'Sclerosing cholangitis';
				case 'crohnsDisease':
					return `Crohn’s disease or ulcerative colitis with any flare-up within
					the past 5 years or any continued use of oral steroid`;
				case 'bleedingRectum':
					return 'Rectal bleeding other than diagnosed as hemorrhoids';
				case 'pancreatitis':
					return 'Pancreatitis';
				case 'chronicKidneyDisease':
					return 'Chronic kidney disease or nephritis';
				case 'bloodInUrine':
					return 'Blood or protein in urine';
				case 'gastrointestinalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'gastrointestinalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// blood
				case 'diabetes':
					return 'Diabetes';
				case 'goiter':
					return 'Goiter or thyroid disorder other than hypothyroidism';
				case 'anemia':
					return 'Anemia';
				case 'bleedingDisorder':
					return 'Bleeding disorder';
				case 'hemophilia':
					return 'Hemophilia';
				case 'sicklecell':
					return 'Sickle cell anemia';
				case 'thalassemia':
					return 'Thalassemia';
				case 'endocrineDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'endocrineDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// immuno
				case 'aids':
					return 'Acquired immune deficiency syndrome (AIDS)';
				case 'arc':
					return 'AIDS related complex (ARC)';
				case 'hiv':
					return 'Human immunodeficiency virus (HIV)';
				case 'immuneSystemDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'immuneSystemDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// head
				case 'brainInjury':
					return 'Traumatic brain injury or post-concussion syndrome with ongoing symptoms';
				case 'rheumatoidArthritis':
					return 'Rheumatoid arthritis';
				case 'ankylosingSpondylitis':
					return 'Ankylosing spondylitis';
				case 'connectiveTissueDisease':
					return 'Connective tissue disease';
				case 'lupus':
					return 'Lupus';
				case 'paralysis':
					return 'Paralysis';
				case 'musculoskeletalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'musculoskeletalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				// psychological
				case 'bipolarDisease':
					return 'Bipolar disease';
				case 'psychosis':
					return 'Psychosis or any psychotic episode';
				case 'contemplatedSuicide':
					return 'Any contemplated or attempted suicide';
				case 'psychologicalDisorderOther':
					if (typeof answerValue === 'boolean' && answerValue === false) {
						return;
					}
					otherDetails = 'psychologicalDisorderOtherDetails';
					return 'Other(' + answerObject[otherDetails] + ')';
				default:
					return;
			}
		}
		return this.props.questions[questionName].replace(regex, '');
	}
}

function mapStateToProps(state: any) {
	return {
		questions: state.question.questions
	};
}

export default connect(mapStateToProps)(JsonAnswerDetails);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/common/JsonAnswerDetails.tsx